import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import ResetPassword, { ForgotPassword } from "@/pages/ResetPassword";
import Dialer from "@/pages/Dialer";
import Connect from "@/pages/Connect";
import Rates from "@/pages/Rates";
import PublicRates from "@/pages/PublicRates";
import CallCountry from "@/pages/CallCountry";
import { CALL_DESTINATIONS } from "@/data/callDestinations";
import History from "@/pages/History";
import Wallet from "@/pages/Wallet";
import Settings from "@/pages/Settings";
import Esim from "@/pages/Esim";
import Send from "@/pages/Send";
import Admin from "@/pages/Admin";
import { Privacy, Terms, About, Contact } from "@/pages/Legal";

function Protected({ children, adminOnly = false }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/app" replace />;
  return children;
}

function RatesSwitch() {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  return user ? <Layout><Rates /></Layout> : <PublicRates />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/rates" element={<RatesSwitch />} />
      {CALL_DESTINATIONS.map((d) => (
        <Route key={d.slug} path={`/call-${d.slug}`} element={<CallCountry dest={d} />} />
      ))}
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/app" element={<Dialer />} />
        <Route path="/connect" element={<Connect />} />
        <Route path="/history" element={<History />} />
        <Route path="/wallet" element={<Wallet />} />
        <Route path="/esim" element={<Esim />} />
        <Route path="/send" element={<Send />} />
        <Route path="/settings" element={<Settings />} />
      </Route>
      <Route
        path="/admin"
        element={
          <Protected adminOnly>
            <Layout />
          </Protected>
        }
      >
        <Route index element={<Admin />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-center" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
